import React from 'react';



import Editors from './editor.js';
const Football = () => {
	return (
		<>
			<Editors id={"Football"}/>
		</>
	);
};
export default Football;
